import { useGoogleAnalytics } from "tanstack-router-ga4";
import { chrome } from "@/content/chrome";
import { defaultLocale, type Locale } from "@/i18n/locales";
import { appStoreUrl, PLAY_STORE_URL } from "@/lib/site";
import { cn } from "@/lib/utils";

type StoreButtonsProps = {
  locale?: Locale;
  className?: string;
};

export function StoreButtons({
  locale = defaultLocale,
  className,
}: StoreButtonsProps) {
  const store = chrome[locale].store;
  const ga = useGoogleAnalytics();

  return (
    <div
      className={cn("flex flex-col items-center gap-3 sm:flex-row", className)}
    >
      <a
        href={appStoreUrl(locale)}
        target="_blank"
        rel="noopener noreferrer"
        className="transition-opacity hover:opacity-85"
        onClick={() =>
          ga.event("download_app", { store: "apple", transport_type: "beacon" })
        }
      >
        <img
          src="/images/store/app-store.svg"
          alt={store.appStoreAlt}
          width={180}
          height={53}
          className="h-12 sm:h-14"
        />
      </a>
      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="transition-opacity hover:opacity-85"
        onClick={() =>
          ga.event("download_app", { store: "google", transport_type: "beacon" })
        }
      >
        <img
          src="/images/store/google-play.svg"
          alt={store.playAlt}
          width={180}
          height={53}
          className="h-12 sm:h-14"
        />
      </a>
    </div>
  );
}

export default StoreButtons;
